import React, { Component } from 'react';
// import logo from './logo.png';
import './App.css';
import Graph from './pages/graph/Graph';
import Pump from './pages/relaySwitchDemo/Pump';
import Relay from './pages/relaySwitchDemo/Relay';
import ProfileV2 from './pages/profile/ProfileV2';
import DeviceConfig from './DeviceConfig';
import TransmissionsPage from './pages/transmissions/TransmissionsPage';
import AlarmsExport from './pages/alarms/AlarmsExport';
import AlarmConfig from './AlarmConfig';
import FlowGenerator from './FlowGenerator';
import CustomerInfo from './CustomerInfo';
import DeviceCountersStatistics from './DeviceCountersStatistics';
import LicensePage from './pages/license/License';
import Dashboard from './Dashboard';
import DeviceCountersGraph from './DeviceCountersGraph';
import EventValueRangePage from './pages/eventValueRage/EventValueRange';
import DeviceCountersCumulativeGraph from './DeviceCountersCumulativeGraph';
// import DeviceCountersHistogram from './DeviceCountersHistogram';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { Route, Routes } from 'react-router-dom';
// https://github.com/gillisd/react-router-v4-redux-auth/blob/master/client/src/index.js
//http://www.svlada.com/jwt-token-authentication-with-spring-boot/
import ConfirmRegistration from './components/auth/confirm_registration';
import JssProvider from 'react-jss/lib/JssProvider';

import { create } from 'jss';
import { createGenerateClassName, jssPreset } from '@mui/styles';
import ChangePassword from './PasswordChange';

import connect from 'react-redux/es/connect/connect';
import * as actions from './actions';
import { withTranslation } from 'react-i18next';
import Users from './pages/users/Users';
import LicenseManager from './LicenseManager';
import AccountsPage from './pages/accounts/AccountsPage';
import DeviceSearch from './pages/deviceSearch/DeviceSearch';
import DeviceGroups from './pages/device_groups/DeviceGroups';
import Commands from './pages/commands/CommandsPageSwitch';
import CopyConfigPage from './pages/copyConfig/CopyConfigPage';
import { cyan } from '@mui/material/colors';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Statistics from './pages/statistics/Statistics';
import BasePage from './pages/base/BasePage';
import Location from './pages/location/Location';
import DevicePrediction from './pages/devicePrediction/DevicePrediction';
import { ReactQueryWrapper } from '@thingslog/queries';
import {
  ModalProvider,
  ToastProvider,
  MuiCoreLocale,
  DatePickerLocale,
  DataGridLocale,
} from '@thingslog/ui-components';
import CountersExport from './pages/countersExport/CountersExport';
import ConsumptionExport from './pages/consumptionExport/ConsumptionExport';
import DevicesPage from './pages/devices/DevicesPage';
import Inventory from './pages/inventory/Inventory';
import PrivateOutlet from './components/auth/privateOutlet';
import LicenseValidator from './common/LicenseValidator';
import DevicesSignalV2 from './pages/signal/DevicesSignalPageV2';
import DeviceBatteryPageV2 from './pages/battery/DeviceBatteryPageV2';
import GoogleAnalyticsService from './common/GoogleAnalyticsService';
import i18n from '../src/i18n';
import { PageIds } from './model/Navigation/PageIds';
import GraphV2 from './pages/graphV2/GraphV2';
import BillingReport from './pages/billingReport/BillingReport';
import UtilityRatePage from './pages/utilityRate/UtilityRate.page';
import { IconsPage } from './pages/icons/Icon.page';
import { AddIconPage } from './pages/icons/AddIcon.page';
import SettingsV2 from './pages/settings/SettingsV2';
import { setDefaultOptions } from 'date-fns';
import { bg, de, enGB, el, es, ru } from 'date-fns/locale';
import LicenseError from './pages/licenseError/LicenseError';
import LinkDevicesV2 from './pages/linkDevices/LinkDevicesV2';
import LinkDevices from './LinkDevices';
import { DashboardDefault, DashboardPage, DashboardsPage } from './pages/dashboard';
import CustomerBillingReport from './pages/customerBillingReport/CustomerBillingReport';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import SensorsAndNetworkConfig from './pages/sensorsAndNetworkConfig/SensorsAndNetworkConfig';
import Documentation from './pages/documentation/Documentation';
import { DeviceNodesPage } from './pages/deviceNodes/DeviceNodes.page';
import { PostHogProvider } from 'posthog-js/react';
import themePreset from './config/theme';
import {
  GeneratedScheduledReports,
  ScheduledReportConfigs,
  CreateScheduledReportConfig,
  EditScheduledReportConfig,
} from './pages/scheduledReports';
import { SensorsDataPage } from './pages/sensors-data';
import { SessionAuthProvider, SessionAuthSetup } from '@thingslog/utils';
import { clearSessionUser, getSessionUser, setSessionUser } from './common/sessionUser';
import Axios from './clients/Axios/Axios';
import DocumentationPDFViewer from './pages/documentation/DocumentationPDFViewer';

const generateClassName = createGenerateClassName({
  productionPrefix: 'c',
});
const jss = create(jssPreset());

export const global_env = {
  version: process.env.REACT_APP_VERSION,
  posthogApiKey: process.env.REACT_APP_POSTHOG_KEY,
  posthogHost: process.env.REACT_APP_POSTHOG_REGION,
};

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.locales = { bg: bg, de: de, en: enGB, gr: el, ru: ru, es: es };
  }
  componentDidMount() {
    this.props.i18n.changeLanguage(this.props.auth.language || 'en');
    if (this.props.auth.language) {
      setDefaultOptions({ locale: this.locales[this.props.auth.language] });
    }
    GoogleAnalyticsService.initGA();
  }

  isFeatureFlagOn = (flagName) => {
    return this.props.featureFlags.featureFlagsArray.includes(flagName);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.featureFlags.featureFlagsArray !== this.props.featureFlags.featureFlagsArray) {
      this.setState({});
    }

    if (prevProps.auth.language !== this.props.auth.language && this.props.auth.language) {
      this.props.i18n.changeLanguage(this.props.auth.language);
      setDefaultOptions({ locale: this.locales[this.props.auth.language] });
    }
  }
  render() {
    const theme = createTheme(
      themePreset,
      DataGridLocale[i18n.language],
      MuiCoreLocale[i18n.language],
      DatePickerLocale[i18n.language]
    );

    return (
      <SessionAuthProvider
        Axios={Axios}
        onSuccessfulAuthentication={(user) => {
          const previousUser = getSessionUser();
          const hasCompanySelectionRole = (user.roles || []).some(
            (role) => role.authority === 'ROLE_ADMIN' || role.authority === 'ROLE_SUPER_ADMIN'
          );

          if (
            !previousUser?.email ||
            previousUser.email !== user.email ||
            !hasCompanySelectionRole
          ) {
            localStorage.removeItem('selectedCompany');
          }

          const selectedCompany = localStorage.getItem('selectedCompany');
          if (selectedCompany) {
            this.props.companySelected(JSON.parse(selectedCompany));
          }

          setSessionUser(user);
          this.props.authUser({
            authenticated: true,
            companyName: user.companyName,
            companyId: user.companyId,
            email: user.email,
            error: null,
            isDashboardEnabled: user.isDashboardEnabled,
            language: user.language,
            signedup: true,
            roles: user.roles,
            username: user.sub,
          });
        }}
        onFailedAuthentication={() => {
          clearSessionUser();
          localStorage.removeItem('selectedCompany');
        }}
      >
        <PostHogProvider
          apiKey={global_env.posthogApiKey}
          options={{
            api_host: global_env.posthogHost,
            defaults: '2025-05-24',
            capture_pageview: false,
            capture_pageleave: false,
            capture_performance: false,
            capture_heatmaps: false,
            capture_exceptions: false,
            capture_dead_clicks: false,
            autocapture: false,
          }}
        >
          <ReactQueryWrapper>
            <JssProvider jss={jss} generateClassName={generateClassName}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                  <ModalProvider>
                    <ToastProvider>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <div className="App">
                          <SessionAuthSetup
                            Axios={Axios}
                            onRequest={(request) => {
                              const isPublic = window.runConfig?.autoAuth?.some(
                                (a) => a.url === window.location.hostname && a.isPublic
                              );
                              if (isPublic) {
                                request.url = request.url.replace('/api', '/public-api');
                                window.location.href = `${window.location.origin}/portal`;
                              }
                              return request;
                            }}
                            onErrorCode={(statusCode, error) => {
                              switch (statusCode) {
                                case 401:
                                  break;
                                case 403:
                                  const errorCode = error.response.data.errorCode;
                                  switch (errorCode) {
                                    case 'NO_VALID_OR_ACTIVE_LICENSE':
                                      if (window.location.pathname !== '/app/restricted-access') {
                                        window.location.href = `${window.location.origin}/app/restricted-access`;
                                      }
                                      break;
                                    default:
                                      if (
                                        window.location.pathname !== '/app?error=forbidden' &&
                                        window.location.pathname !== '/app/signin'
                                      ) {
                                        window.location.href = `${window.location.origin}/app?error=forbidden`;
                                      }
                                  }
                                  break;
                                default:
                                  break;
                              }
                            }}
                          />
                          <Routes>
                            <Route
                              path="/app/confirm-registration"
                              element={<ConfirmRegistration />}
                            />
                            <Route
                              path="/app/Pump"
                              element={<PrivateOutlet pageId={PageIds.LINK_PUMP} />}
                            >
                              <Route path="/app/Pump" element={<Pump />} />
                            </Route>
                            <Route
                              path="/app/Relay"
                              element={<PrivateOutlet pageId={PageIds.LINK_RELAY} />}
                            >
                              <Route path="/app/Relay" element={<Relay />} />
                            </Route>
                            <Route
                              path="/"
                              element={<PrivateOutlet pageId={PageIds.LINK_HOME_PAGE} />}
                            >
                              <Route path="/" exact={true} element={<BasePage />} />
                            </Route>
                            <Route
                              path="/app"
                              element={<PrivateOutlet pageId={PageIds.LINK_DASHBOARD} />}
                            >
                              <Route path="/app" exact={true} element={<Dashboard />} />
                            </Route>
                            <Route
                              path="/app/Profile"
                              element={
                                <PrivateOutlet
                                  pageId={PageIds.LINK_PROFILE}
                                  isNonRestrictedAccess={true}
                                />
                              }
                            >
                              <Route path="/app/Profile" element={<ProfileV2 />} />
                            </Route>
                            <Route
                              path="/app/Devices"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_USER']}
                                  pageId={PageIds.LINK_DEVICES}
                                />
                              }
                            >
                              <Route path="/app/Devices" element={<DevicesPage />} />
                            </Route>
                            <Route
                              path="/app/dashboard"
                              element={<PrivateOutlet pageId={PageIds.LINK_DASHBOARD_2} />}
                            >
                              <Route path="/app/dashboard" element={<DashboardDefault />} />
                            </Route>
                            <Route
                              path="/app/dashboards"
                              element={<PrivateOutlet pageId={PageIds.LINK_DASHBOARD_2} />}
                            >
                              <Route path="/app/dashboards" element={<DashboardsPage />} />
                              <Route path="/app/dashboards/:id" element={<DashboardPage />} />
                            </Route>

                            <Route
                              path="/app/DeviceGroups"
                              element={<PrivateOutlet pageId={PageIds.LINK_DEVICE_GROUPS} />}
                            >
                              <Route path="/app/DeviceGroups" element={<DeviceGroups />} />
                            </Route>
                            <Route
                              path="/app/UtilityRates"
                              allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                              element={<PrivateOutlet pageId={PageIds.LINK_UTILITY_RATE} />}
                            >
                              <Route path="/app/UtilityRates" element={<UtilityRatePage />} />
                            </Route>
                            <Route
                              path="/app/Graph/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_NEW_GRAPH_DEVICE} />}
                            >
                              <Route path="/app/Graph/:deviceNumber" element={<Graph />} />
                            </Route>
                            <Route
                              path="/app/DeviceCounters/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_READINGS_DEVICE} />}
                            >
                              <Route
                                path="/app/DeviceCounters/:deviceNumber"
                                element={<CountersExport />}
                              />
                            </Route>
                            <Route
                              path="/app/Commands/:deviceNumber"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_COMMANDS_DEVICE}
                                />
                              }
                            >
                              <Route path="/app/Commands/:deviceNumber" element={<Commands />} />
                            </Route>
                            <Route
                              path="/app/CopyConfig/:deviceNumber"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_COPY_CONFIG_DEVICE}
                                />
                              }
                            >
                              <Route
                                path="/app/CopyConfig/:deviceNumber"
                                element={<CopyConfigPage />}
                              />
                            </Route>
                            <Route
                              path="/app/LinkDevices/"
                              element={
                                <PrivateOutlet
                                  pageId={PageIds.LINK_LINK_DEVICE}
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                />
                              }
                            >
                              {this.isFeatureFlagOn('LINK_DEVICE_LICENSE_CHECK') ? (
                                <Route path="/app/LinkDevices/" element={<LinkDevicesV2 />} />
                              ) : (
                                <Route path="/app/LinkDevices/" element={<LinkDevices />} />
                              )}
                            </Route>

                            <Route
                              path="/app/DeviceCompanyLookup"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_DEVICE_ACCOUNT_LOOKUP}
                                />
                              }
                            >
                              <Route path="/app/DeviceCompanyLookup" element={<DeviceSearch />} />
                            </Route>
                            <Route
                              path="/app/DeviceConfig/:deviceNumber"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_CONFIG_DEVICE}
                                />
                              }
                            >
                              <Route
                                path="/app/DeviceConfig/:deviceNumber"
                                element={<DeviceConfig />}
                              />
                            </Route>
                            <Route
                              path="/app/DeviceCountersStatistics/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_STATISTICS_DEVICE} />}
                            >
                              <Route
                                path="/app/DeviceCountersStatistics/:deviceNumber"
                                element={<Statistics />}
                              />
                            </Route>
                            <Route
                              path="/app/CustomerInfo/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_CUSTOMER_DEVICE} />}
                            >
                              <Route
                                path="/app/CustomerInfo/:deviceNumber"
                                element={<CustomerInfo />}
                              />
                            </Route>
                            <Route
                              path="/app/DeviceCountersExport/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_EXPORT_DEVICE} />}
                            >
                              <Route
                                path="/app/DeviceCountersExport/:deviceNumber"
                                element={<CountersExport />}
                              />
                            </Route>
                            <Route
                              path="/app/DeviceCountersExport"
                              element={
                                <PrivateOutlet
                                  pageId={PageIds.LINK_EXPORT}
                                  requireSelectedCompanyAsSuperAdmin={true}
                                />
                              }
                            >
                              <Route
                                path="/app/DeviceCountersExport"
                                element={<CountersExport />}
                              />
                            </Route>
                            <Route
                              path="/app/DeviceSignals/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_SIGNAL_DEVICE} />}
                            >
                              <Route
                                path="/app/DeviceSignals/:deviceNumber"
                                element={<DevicesSignalV2 />}
                              />
                            </Route>
                            <Route
                              path="/app/DeviceBattery/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_BATTERY_DEVICE} />}
                            >
                              <Route
                                path="/app/DeviceBattery/:deviceNumber"
                                element={<DeviceBatteryPageV2 />}
                              />
                            </Route>
                            <Route
                              path="/app/DeviceCountersGraph/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_FLOW_DEVICE} />}
                            >
                              <Route
                                path="/app/DeviceCountersGraph/:deviceNumber"
                                element={<DeviceCountersGraph />}
                              />
                            </Route>
                            <Route
                              path="/app/DeviceCountersCumulativeGraph/:deviceNumber"
                              element={
                                <PrivateOutlet
                                  pageId={PageIds.LINK_DEVICE_COUNTERS_CUMULATIVE_GRAPH}
                                />
                              }
                            >
                              <Route
                                path="/app/DeviceCountersCumulativeGraph/:deviceNumber"
                                element={<DeviceCountersCumulativeGraph />}
                              />
                            </Route>
                            <Route
                              path="/app/Transmissions"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_TRANSMISSIONS}
                                />
                              }
                            >
                              <Route path="/app/Transmissions" element={<TransmissionsPage />} />
                            </Route>
                            <Route
                              path="/app/DeviceInventory"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_INVENTORY}
                                />
                              }
                            >
                              <Route path="/app/DeviceInventory" element={<Inventory />} />
                            </Route>
                            <Route
                              path="/app/Alarms"
                              element={<PrivateOutlet pageId={PageIds.LINK_ALARMS_DEVICE} />}
                            >
                              <Route index element={<AlarmsExport />} />
                              <Route path=":deviceNumber" element={<AlarmsExport />} />
                            </Route>
                            <Route
                              path="/app/AllAlarms"
                              element={<PrivateOutlet pageId={PageIds.LINK_ALARMS} />}
                            >
                              <Route path="/app/AllAlarms" element={<AlarmsExport />} />
                              <Route path="/app/AllAlarms/:alarmType" element={<AlarmsExport />} />
                            </Route>
                            <Route
                              path="/app/AlarmConfig/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_ALARM_CONFIG_DEVICE} />}
                            >
                              <Route
                                path="/app/AlarmConfig/:deviceNumber"
                                element={<AlarmConfig />}
                              />
                            </Route>
                            <Route
                              path="/app/FlowGenerator/:deviceNumber"
                              element={
                                <PrivateOutlet pageId={PageIds.LINK_FLOW_GENERATOR_DEVICE} />
                              }
                            >
                              <Route
                                path="/app/FlowGenerator/:deviceNumber"
                                element={<FlowGenerator />}
                              />
                            </Route>
                            <Route
                              path="/app/DeviceLocation"
                              element={<PrivateOutlet pageId={PageIds.LINK_MAP} />}
                            >
                              <Route index element={<Location />} />
                            </Route>
                            <Route
                              path="/app/DeviceLocation/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_MAP_DEVICE} />}
                            >
                              <Route
                                path="/app/DeviceLocation/:deviceNumber"
                                element={<Location />}
                              />
                            </Route>
                            <Route
                              path="/app/DevicesBattery"
                              element={<PrivateOutlet pageId={PageIds.LINK_BATTERY} />}
                            >
                              <Route path="/app/DevicesBattery" element={<DeviceBatteryPageV2 />} />
                              <Route
                                path="/app/DevicesBattery/:fromLevel"
                                element={<DeviceBatteryPageV2 />}
                              />
                            </Route>
                            <Route
                              path="/app/DevicesSignal"
                              element={<PrivateOutlet pageId={PageIds.LINK_SIGNAL} />}
                            >
                              <Route path="/app/DevicesSignal" element={<DevicesSignalV2 />} />
                              <Route
                                path="/app/DevicesSignal/:fromLevel"
                                element={<DevicesSignalV2 />}
                              />
                            </Route>
                            <Route
                              path="/app/ChangePassword/"
                              element={<PrivateOutlet pageId={PageIds.LINK_CHANGE_PASSWORD} />}
                            >
                              <Route path="/app/ChangePassword/" element={<ChangePassword />} />
                            </Route>
                            <Route
                              path="/app/Users/"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_SHOW_USERS}
                                />
                              }
                            >
                              <Route path="/app/Users/" element={<Users />} />
                            </Route>
                            <Route
                              path="/app/Accounts/"
                              allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                              element={<PrivateOutlet pageId={PageIds.LINK_ACCOUNTS} />}
                            >
                              <Route path="/app/Accounts/" element={<AccountsPage />} />
                            </Route>

                            <Route
                              path="/app/ReportsExport/"
                              element={
                                <PrivateOutlet
                                  pageId={PageIds.LINK_REPORTS}
                                  requireSelectedCompanyAsSuperAdmin={true}
                                />
                              }
                            >
                              <Route path="/app/ReportsExport/" element={<ConsumptionExport />} />
                            </Route>
                            <Route
                              path="/app/LicenseManager/"
                              element={<PrivateOutlet pageId={PageIds.LINK_LICENSE_MANAGER} />}
                            >
                              <Route path="/app/LicenseManager/" element={<LicenseManager />} />
                            </Route>
                            <Route
                              path="/app/Licenses/"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_LICENSES}
                                />
                              }
                            >
                              {this.props.auth.hasLicensesAccess && (
                                <Route path="/app/Licenses/" element={<LicensePage />} />
                              )}
                            </Route>
                            <Route
                              path="/app/DevicePrediction/:deviceNumber"
                              element={
                                <PrivateOutlet pageId={PageIds.LINK_DEVICE_PREDICTION_DEVICE} />
                              }
                            >
                              <Route
                                path="/app/DevicePrediction/:deviceNumber"
                                element={<DevicePrediction />}
                              />
                            </Route>
                            <Route
                              path="/app/EventValueRange/:deviceNumber"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_VALUE_RANGES_DEVICE}
                                />
                              }
                            >
                              <Route
                                path="/app/EventValueRange/:deviceNumber"
                                element={<EventValueRangePage />}
                              />
                            </Route>
                            <Route path="/app/Settings/" element={<PrivateOutlet />}>
                              <Route path="/app/Settings/" element={<SettingsV2 />} />
                            </Route>
                            <Route path="/app/docs" element={<PrivateOutlet />}>
                              {this.isFeatureFlagOn('NEW_DOCUMENTATION_PAGE') ? (
                                <Route path="/app/docs" element={<DocumentationPDFViewer />} />
                              ) : (
                                <Route path="/app/docs" element={<Documentation />} />
                              )}
                            </Route>
                            <Route
                              path="/app/NewGraph"
                              element={<PrivateOutlet pageId={PageIds.LINK_NEW_GRAPH} />}
                            >
                              <Route path="/app/NewGraph" element={<GraphV2 />} />
                            </Route>
                            <Route
                              path="/app/BillingReport"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_BILLING_REPORT}
                                />
                              }
                            >
                              <Route path="/app/BillingReport" element={<BillingReport />} />
                            </Route>
                            <Route
                              path="/app/icons"
                              element={
                                <PrivateOutlet
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']}
                                  pageId={PageIds.LINK_ICONS}
                                />
                              }
                            >
                              <Route path="/app/icons" element={<IconsPage />} />
                            </Route>
                            <Route
                              path="/app/icons/add"
                              element={<PrivateOutlet pageId={PageIds.LINK_ICONS} />}
                            >
                              <Route path="/app/icons/add" element={<AddIconPage />} />
                            </Route>
                            <Route
                              path="/app/CustomerBillingReport"
                              element={
                                <PrivateOutlet
                                  pageId={PageIds.LINK_CUSTOMER_BILLING_REPORT}
                                  allowedRoles={['ROLE_SUPER_ADMIN', 'ROLE_BILLING']}
                                />
                              }
                            >
                              <Route
                                path="/app/CustomerBillingReport"
                                element={<CustomerBillingReport />}
                              />
                            </Route>
                            <Route
                              path="/app/ParametersConfiguration/:deviceNumber"
                              element={
                                <PrivateOutlet
                                  pageId={PageIds.LINK_SENSORS_AND_NETWORK_CONFIG}
                                  allowedRoles={['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
                                />
                              }
                            >
                              <Route
                                path="/app/ParametersConfiguration/:deviceNumber"
                                element={<SensorsAndNetworkConfig />}
                              />
                            </Route>
                            <Route
                              path="/app/restricted-access"
                              element={
                                <PrivateOutlet
                                  pageId={PageIds.RESTRICTED_ACCESS}
                                  isNonRestrictedAccess={true}
                                />
                              }
                            >
                              <Route path="" element={<LicenseError />} />
                            </Route>
                            <Route
                              path="/app/DeviceNodes"
                              element={<PrivateOutlet pageId={PageIds.LINK_DEVICE_NODES} />}
                            >
                              <Route path="" element={<DeviceNodesPage />} />
                            </Route>
                            <Route
                              path="/app/GeneratedScheduledReports"
                              element={<PrivateOutlet pageId={PageIds.LINK_REPORTS} />}
                            >
                              <Route
                                path="/app/GeneratedScheduledReports"
                                element={<GeneratedScheduledReports />}
                              />
                            </Route>
                            <Route
                              path="/app/ScheduledReportsConfig"
                              element={<PrivateOutlet pageId={PageIds.LINK_SCHEDULED_REPORTS} />}
                            >
                              <Route
                                path="/app/ScheduledReportsConfig"
                                element={<ScheduledReportConfigs />}
                              />
                            </Route>
                            <Route
                              path="/app/ScheduledReportsConfig/create"
                              element={<PrivateOutlet pageId={PageIds.LINK_SCHEDULED_REPORTS} />}
                            >
                              <Route
                                path="/app/ScheduledReportsConfig/create"
                                element={<CreateScheduledReportConfig />}
                              />
                            </Route>
                            <Route
                              path="/app/ScheduledReportsConfig/edit/:reportName"
                              element={<PrivateOutlet pageId={PageIds.LINK_SCHEDULED_REPORTS} />}
                            >
                              <Route
                                path="/app/ScheduledReportsConfig/edit/:reportName"
                                element={<EditScheduledReportConfig />}
                              />
                            </Route>
                            <Route
                              path="/app/SensorsData"
                              element={<PrivateOutlet pageId={PageIds.LINK_SENSORS_DATA} />}
                            >
                              <Route path="/app/SensorsData" element={<SensorsDataPage />} />
                            </Route>
                            <Route
                              path="/app/SensorsData/:deviceNumber"
                              element={<PrivateOutlet pageId={PageIds.LINK_SENSORS_DATA} />}
                            >
                              <Route
                                path="/app/SensorsData/:deviceNumber"
                                element={<SensorsDataPage />}
                              />
                            </Route>
                          </Routes>
                        </div>
                      </LocalizationProvider>
                    </ToastProvider>
                  </ModalProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </JssProvider>
          </ReactQueryWrapper>
        </PostHogProvider>
      </SessionAuthProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    featureFlags: state.featureFlags,
  };
}

export default connect(mapStateToProps, actions)(withTranslation()(App));
